<div class="col-sm-12 offset-md-1 col-md-10  mt-3">
    <div class="form-logo">
        <a href="javascript:void(0)" (click)="openLink('HOMPAGE_BASE_URL','','_self');">
            <img [src]="this.logo_url" alt="egd-logo">
        </a>
    </div>
    <div class="form-back  h4 my-4">
        <a [routerLink]="['/', this.slug, 'user', 'login', 'patient']">&#8592; Back</a>
    </div>
    <div class="form-heading-section mt-4">
        <h2>Forgot User ID - Patient</h2>
        <p class="form-sub-heading">
            Don't worry we've got you covered.
        </p>
        <p class="form-tagline"><small>Forgot User ID</small></p>
    </div>

    <div class="form-div my-4">
        <p *ngIf="forgotEmailDone==true && this.response.data.email">Your email id is {{this.response.data.email}}</p>
        <p *ngIf="forgotEmailDone==true && this.response.data.phone">Your phone number is {{this.response.data.phone}}
        </p>
        <form #forgotEmailForm="ngForm" (ngSubmit)="patientForgotEmailSubmit()" *ngIf="forgotEmailDone==false"
            accept-charset="UTF-8">
            <div class="form-group row pl-md-1">
                <label class="col-sm-12" for="name">Name*</label>
                <!-- <div class="row forgot-email-content"> -->
                <div class="col-sm-12 col-md-6">
                    <input type="text" class="form-control rounded-pill" id="firstname" name="firstname"
                        aria-describedby="name" placeholder="First Name*" [(ngModel)]="this.userPatient.first_name"
                        #first_name="ngModel" [pKeyFilter]="name_input"
                        [class.form-input-error]="(first_name.invalid && (first_name.dirty || first_name.touched)) && (first_name.errors.required)"
                        [class.form-input-success]="(!first_name.invalid && (first_name.dirty || first_name.touched)) && !(first_name.errors?.required)"
                        required>
                    <!-- <small class="form-error-msg text-center">*First name required</small> -->
                    <div *ngIf="first_name.invalid && (first_name.dirty || first_name.touched)" class="col-sm-12">
                        <div *ngIf="first_name.errors.required" class="col-sm-12 alert alert-danger m-2" role="alert">
                            First name is required.
                        </div>
                        <div *ngIf="first_name.errors.FieldValidator" class="col-sm-12 alert alert-danger m-2"
                            role="alert">
                            Invalid First name.
                        </div>
                    </div>
                </div>


                <div class="input-div col-sm-12 col-md-6">
                    <input type="text" class="form-control rounded-pill" id="middlename" name="middlename"
                        aria-describedby="middlename" placeholder="Middle Name"
                        [(ngModel)]="this.userPatient.middle_name" [pKeyFilter]="name_input">
                </div>
            </div>
            <div class="form-group row">
                <div class="col-md-12 col-sm-12">
                    <input type="text" class="form-control rounded-pill" id="lastname" name="lastname"
                        aria-describedby="lastname" placeholder="Last Name*" [(ngModel)]="this.userPatient.last_name"
                        #last_name="ngModel" [pKeyFilter]="name_input"
                        [class.form-input-error]="(last_name.invalid && (last_name.dirty || last_name.touched)) && (last_name.errors.required)"
                        [class.form-input-success]="(!last_name.invalid && (last_name.dirty || last_name.touched)) && !(last_name.errors?.required)"
                        required>
                    <!-- <small class="form-error-msg text-center">*Last name required</small> -->
                    <div *ngIf="last_name.invalid && (last_name.dirty || last_name.touched)" class="col-sm-12 px-0">
                        <div *ngIf="last_name.errors.required" class="col-sm-12 alert alert-danger m-2" role="alert">
                            Last name is required.
                        </div>
                        <div *ngIf="last_name.errors.FieldValidator" class="col-sm-12 alert alert-danger m-2"
                            role="alert">
                            Invalid Last name.
                        </div>
                    </div>
                </div>
            </div>


            <!-- </div> -->


            <div class="form-group row">
                <!-- <div class="row forgot-email-content"> -->
                <div class="col-sm-12">
                    <div class="row">
                        <label class="col-sm-12" for="date">Date of Birth*</label>
                        <div class="col-md-12 col-sm-12">
                            <p-calendar id="dob" name="dob" class="notranslate" [defaultDate]="max_date" [maxDate]="max_date" id="dob"
                                FieldValidator="Dob" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"
                                placeholder="Date of Birth (MM/DD/YYYY)" dateFormat="dd/mm/yy"
                                [(ngModel)]="this.userPatient.date_of_birth_date" [monthNavigator]="true"
                                [yearNavigator]="true" yearRange="1900:2099" [showIcon]="false" placeholder="dd/mm/yyyy"
                                #date_of_birth="ngModel"
                                [ngClass]="{'p-calendar-success':(!date_of_birth.invalid && (date_of_birth.dirty || date_of_birth.touched)) && !(date_of_birth.errors?.required &&  date_of_birth.errors?.FieldValidator), 'p-calendar-error' :(date_of_birth.invalid && (date_of_birth.dirty || date_of_birth.touched)) && (date_of_birth.errors?.required ||  date_of_birth.errors?.FieldValidator)}"
                                required>
                            </p-calendar>
                            <div *ngIf="date_of_birth.invalid && (date_of_birth.dirty || date_of_birth.touched)"
                                class="col-sm-12">
                                <div *ngIf="date_of_birth.errors.required" class="col-sm-12 alert alert-danger m-2"
                                    role="alert">
                                    Date of Birth is required.
                                </div>
                                <div *ngIf="date_of_birth.errors.FieldValidator"
                                    class="col-sm-12 alert alert-danger m-2" role="alert">
                                    Invalid Date Of Birth. User must be at least 18.
                                </div>
                            </div>
                        </div>
                        <!-- <div class="col-sm-1 m-auto"></div> -->

                    </div>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-sm-12">
                    <div class="row">
                        <label class="col-sm-12" for="country">Country*</label>
                        <div class="col-sm-12">
                            <select name="country" class="custom-select custom-select mb-3"
                                [(ngModel)]="this.userPatient.country_id" #country="ngModel"
                                [class.form-input-error]="(country.invalid && (country.dirty || country.touched)) && (country.errors.required)"
                                [class.form-input-success]="(!country.invalid && (country.dirty || country.touched)) && !(country.errors?.required)"
                                required>
                                <option value=null disabled selected>Choose your country</option>
                                <option *ngFor="let country of this.countries" value={{country.value}}>
                                    {{country.label}}</option>
                            </select>
                            <!-- <small class="form-error-msg text-center">*Kindly select country</small> -->
                            <div *ngIf="country.invalid && (country.dirty || country.touched)" class="col-sm-12">
                                <div *ngIf="country.errors.required" class="col-sm-12 alert alert-danger m-2"
                                    role="alert">
                                    Country is required.
                                </div>
                            </div>
                        </div>
                        <!-- <div class="col-sm-1 m-auto"></div> -->

                    </div>
                </div>
                <!-- </div> -->
            </div>
            <div class="form-group row justify-content-center">
                <div class="m-3">
                    <div id="recaptcha-div2">
                        <re-captcha *ngIf="this.recaptcha_Reset" class="recaptcha ng-valid" name="recaptcha" matInput
                            style="display: inline-block;" (resolved)="resolved($event)"
                            [(ngModel)]="this.userPatient.recaptcha" #recaptcha="ngModel" [siteKey]="sitekey" required>
                        </re-captcha>
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-sm-12">
                    <div class="form-submit-button mt-5">
                        <button type="submit" [disabled]="!forgotEmailForm.valid || formPosting==true"
                            class="btn btn-primary font-weight-bold text-white p-2">
                            Get My User ID
                        </button>
                    </div>
                </div>
            </div>
        </form>
        <div class="form-submit-button mt-2">
            <button type="button" class="btn btn-primary font-weight-bold text-white p-2" *ngIf="forgotEmailDone==true"
            [routerLink]="['/', this.slug, 'user', 'login', 'patient']">
                Back
            </button>
        </div>
        <div class="mt-3 mx-2">
            <div class="text-center">
                <div class="spinner-border text-primary" role="status" *ngIf="formPosting==true">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
            <!-- <div *ngIf="result.success == false" class="alert alert-danger">
                {{result.error.message}}
            </div> -->
            <!-- <div class="alert alert-danger" *ngIf="this.response?.success!=null && this.response?.success==false"> -->
            <div
                *ngIf="(this.response?.success!=null && this.response?.success==false) && (this.response?.error!=null)">
                <div class="alert alert-danger">{{this.response?.error.message}}</div>
            </div>
            <div
                *ngIf="(this.response?.success!=null && this.response?.success==false) && (this.serverError?.error!=null && this.serverError?.statusCode!=500)">
                <div class="alert alert-danger" *ngFor="let message of this.serverError?.message">{{message}}
                </div>
            </div>
            <div
                *ngIf="(this.response?.success!=null && this.response?.success==false) && (this.serverError?.error!=null && this.serverError?.statusCode==500)">
                <div class="alert alert-danger">{{this.serverError?.message}}</div>
            </div>
            <!-- </div> -->
        </div>
    </div>


    <div class="footer-copyright-section mt-4">
        <p class="footer-copyright-text text-center">
            2025 Copyright <span>&#169;</span> All rights reserved by <a href="javascript:void(0)"
                (click)="openLink('HOMPAGE_BASE_URL','','_self');" style="color: #1850A0;">eGlobalDoctors</a>
        </p>
    </div>

</div>